import { createContext, useContext } from 'react';

interface TickerContextType {
  now: Date;
}

export const TickerContext = createContext<TickerContextType | null>(null);

export const useTickerContext = () => useContext(TickerContext)!;
